<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: 0 }"
      style="height: 550px"
    >
      <template #title>
        <h6 class="font-semibold m-0">Study information</h6>
      </template>

      <a-descriptions class="mb-20" :column="1">
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            ID :
            <span class="text-dark f-18 font-semibold">{{
              dataStudy[0].student_id
            }}</span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Status :
            <span class="text-dark">
              <a-tag color="green">
                {{ dataStudy[0].status }}
              </a-tag>
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">Advisor Name :</p>
          <p class="font-semibold m-0">{{ dataStudy[0].advisor_name }}</p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-20 mb-5 text-muted">
            Major :
            <span class="text-dark">
              [ {{ dataStudy[0].main_curriculum_code }} ] , {{ dataStudy[0].main_curriculum_general_name }}
            </span>
          </p>
          <p class="ml-50 mt-0 mb-0 text-muted">
            <span class="text-muted">
              <i>{{ dataStudy[0].main_curriculum_full_name }}</i>
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Math Track :
            <span class="text-dark">
              {{ dataStudy[0].math_track }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            English Track :
            <span class="text-dark">
              {{ dataStudy[0].english_track }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Intake Term :
            <span class="text-dark">
              {{ dataStudy[0].intake_term_name }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Student Type :
            <span class="text-dark">
              {{ dataStudy[0].student_type }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">Admission mail :</p>
          <p class="font-semibold m-0">{{ dataStudy[0].admission_email }}</p>
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
export default {
  props: {
    dataStudy: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-14 {
  font-size: 14px;
}
</style>